import React from "react";  

import {  
    
} from "./styled";

import ContainerAuthenticated from "containers/Authenticated";
import { Row, Col } from "reactstrap";
import { useHistory } from "react-router-dom";

import DashboardFormsPaycheckUser from "components/Dashboard/Forms/PaycheckUser";

export default function DashboardFormPaycheckUser(){  

    const history = useHistory(); 
    const navigate = to => history.push(`/${ to }`); 

    return ( 
        <>
            <ContainerAuthenticated page={"employee"}> 
                <Row> 
                    <Col sm={12} md={12}>
                        <DashboardFormsPaycheckUser />
                    </Col>
                </Row>
            </ContainerAuthenticated> 
        </>
    );
}